module.exports = __webpack_public_path__ + "img/petit-fute.png";